import React from "react";
import { SecondaryNavigationProps } from "@/types/layout";
import { SecondaryNavItemDropdown } from "@/components/layout/Sidebar/SecondaryNavItemDropdown";
import { SecondaryNavItem } from "@/components/layout/Sidebar/SecondaryNavItem";

export const SecondaryNavigation: React.FC<SecondaryNavigationProps> = ({ navigationItems, postId }) => {
  return (
    <ul className="static border-b border-gray-200 py-[16px] font-condensed text-md font-light dark:border-white-25 lg:relative">
      {navigationItems.map((item, key) => (
        <div key={`secondary-nav-item-${key}`}>
          {item.dropdownMenu ? (
            <SecondaryNavItemDropdown navigationItem={item} />
          ) : (
            <SecondaryNavItem navigationItem={item} postId={postId} />
          )}
        </div>
      ))}
    </ul>
  );
};
